/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

"use strict";


import styled, {css} from "styled-components";
import {colors} from "nxtconstants";

const Heading = styled.h1`
  font-family: ${props => {
    return props.type === "secondary" ? "Avenir-Black" : "Avenir-Heavy";
  }};
  font-weight: initial;
  color : ${props => {
    return props.color ? props.color : colors.white;
  }
};
  font-size : ${props => {
    return props.fontSize ? props.fontSize : "2rem";
  }
};
  line-height : calc(${props => {
    return props.fontSize ? props.fontSize : "2rem";
  }} * 1.5);
};
  ${props => props.additionalStyles && css(...props.additionalStyles)};
}
`;


const SecondaryText = styled.h2`
font-family : 'Avenir-Medium';
color: ${
  props => {
    return props.color ? props.color : colors.black;
  }
};
font-size : ${
  props => {
    return props.fontSize ? props.fontSize : "1.6rem";
  }
};
font-weight : ${
  props => {
    // Normalize fontWeight: use "normal" when absent, parse numeric strings (e.g. "400" from CMS)
    // to numbers with radix 10, and pass through numbers/keywords (400, "bold") as-is
    const fw = props.fontWeight;
    if (!fw) return "normal";
    if (typeof fw === "string" && /^\d+$/.test(fw)) return parseInt(fw, 10);
    return fw;
  }
};
line-height : calc(${props => {
    return props.fontSize ? props.fontSize : "1.6rem";
  }} * 1.5);
};
${props => props.additionalStyles && css(...props.additionalStyles)};
`;

// Prevent custom styling props from reaching the DOM to fix React warnings and W3C validation
const PrimaryText = styled.p.withConfig({
  shouldForwardProp: (prop) => !["color", "fontSize", "additionalStyles", "fontWeight", "type"].includes(prop)
})`
font-family : 'Avenir-Light';
color: ${
  props => {
    return props.color ? props.color : colors.mineShaft;
  }
};
font-size : ${
  props => {
    return props.fontSize ? props.fontSize : "1.6rem";
  }
};
line-height : calc(${props => {
    return props.fontSize ? props.fontSize : "1.6rem";
  }} * 1.5);
};
${props => props.additionalStyles && css(...props.additionalStyles)};
`;


export {Heading, SecondaryText, PrimaryText};
